import React from 'react';
import PropTypes from 'prop-types';

function SectionPanel (props) {
  const {className, children} = props;
  return (
    <section className={'section-base' + (className ? ' ' + className : '')} >
      {children}
    </section>
  );
}

SectionPanel.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string
};

export default SectionPanel;



// WEBPACK FOOTER //
// ./src/ui/Section/SectionPanel.jsx